export const typeOptions: Array<ICheckbox> = [
  {value: 'sale', name: 'حراجی'},
  {value: 'auction', name: 'مزایده'},
  {value: 'prepayment', name: 'سلف'},
  {value: 'simple', name: 'قیمت ثابت'},
];

export const profileOptions: Array<ICheckbox> = [
  {value: 'farmer', name: 'کشاورز'},
  {value: 'wholesaler', name: 'عمده فروش'},
  {value: 'merchant', name: 'بازرگان'},
  {value: 'fridge', name: 'سردخانه'},
  {value: 'complementary_industries', name: 'کارخانه مواد غذایی'},
];
